
import CMS from './CMS';

import { SrcTypes } from './Configuration';

import ExternalConfiguration from '../external-configuration';

const Styles = {
  Empty: '',
  Light: 'light',
}

const Chat = {

  processConfiguration: (loadedConfiguration, auxiliarData) => {
    if( !loadedConfiguration.chat) return null;
    const chatConfiguration = {
      location: `${window.location}`,
      style: Styles.Empty,
      refreshInterval: ExternalConfiguration.ChatDefaults.refreshInterval,
      widthFactor: ExternalConfiguration.ChatDefaults.widthFactor,
      id: loadedConfiguration.chat.id,
      hasRegister: loadedConfiguration.chat.lock,
      showDateAtStart: auxiliarData.srcType === SrcTypes.Vod,
      defaultShowingChat: true,
    };

    return chatConfiguration;
  },

  onResize: (chatConfiguration, showingChat) => {
    const widthFactor = showingChat ? chatConfiguration.widthFactor : 1.0;
    return { width: window.innerWidth * widthFactor, height: window.innerHeight };
  },

  onShowHide: (chatConfiguration, showingChat) => {
    showingChat = !showingChat;
    const { width, height } = Chat.onResize( chatConfiguration, showingChat);
    return { width, height, showingChat };
  },

  loadMessages: chatConfiguration => {
    return CMS.Chat.loadMessages( chatConfiguration.id);
  },

  publishMessage: (chatConfiguration, sessionToken, text, userName) => {
    return CMS.Chat.publishMessage( chatConfiguration.id, sessionToken, text, userName);
  },

  login: (chatConfiguration, mail, password) => {
    return CMS.Chat.login( chatConfiguration.id, mail, password);
  },

  register: (chatConfiguration, name, userName, password, mail) => {
    return CMS.Chat.register( chatConfiguration.id, name, userName, password, mail);
  },

  resendActivationToken: (chatConfiguration, mail) => {
    return CMS.Chat.resendActivationToken( chatConfiguration.id, mail);
  },

  resetPassword: (chatConfiguration, mail) => {
    return CMS.Chat.resetPassword( chatConfiguration.id, chatConfiguration.location, mail);
  },

  changePassword: (chatConfiguration, sessionToken, password) => {
    return CMS.Chat.changePassword( chatConfiguration.id, sessionToken, password);
  },

  socialLogin: (chatConfiguration, userName, socialId, mail, socialNetwork) => {
    return CMS.Chat.socialLogin( chatConfiguration.id, userName, socialId, mail, socialNetwork);
  },
  
};

export default Chat;
